import { Service } from '@angular/core';
import { PageState, PageStateBase, PageStateService, PageDataServiceBase } from '@portal-core/data/page/services/page.state';
import { Project } from '@portal-core/projects/models/project.model';
import { ProjectsState } from '@portal-core/projects/services/projects-data.service';

@PageState({
  name: 'projectPageState',
  actionName: 'ProjectPage'
})
export class ProjectPageState extends PageStateBase {}

@Service()
@PageStateService<Project>({
  pageState: ProjectPageState,
  itemCollectionState: ProjectsState
})
export class ProjectPageDataService extends PageDataServiceBase<Project> {
  override state = ProjectPageState;
}
